import React from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from 'semantic-ui-react'
import moment from 'moment'

import  MatrixTable from './components/tables/matrix_table'
import ShareModal from './components/modals/share'
import AppComponent from './components/app_component'
import OutClick from './components/outclick';

import { getTagMatrix, exportToExcel, updateTag } from '../actions/v2_tags'
import { getUsers } from '../actions/user'
import { createTrainingRequirement, updateTrainingRequirement } from '../actions/training_requirements'

class TagMatrix extends AppComponent {
  constructor(props){
    super(props);

    this.state = {
      tagId: props.tagId,
      tagName: props.tagName,
      trainingMatrix: [],
      trainingModules: [],
      restrictUpdate: false,
      showShareModal: false,
      users: [],
      user: {},
      managers: [],
      legendsPopupShown: false,
      includeArchivedTrainees: false,
      isExportingArchived: false
    }

    this.currentRowIndex = null;
  }

  // FUNCTIONS FOR DATA MANIPULATION
  componentDidMount() {
    if(this.props.tagName) {
      this.setState({
        tagId: this.props.tagId,
        tagName: this.props.tagName,
        trainingMatrix: [],
        loading: true,
        restrictUpdate: false
      },()=>{
        this.getMatrix()
      })
    }
  }

  componentWillReceiveProps(nextProps){
    if(this.props.tagName !== nextProps.tagName) {
      this.setState({
        tagId: nextProps.tagId,
        tagName: nextProps.tagName,
        trainingMatrix: [],
        loading: true,
        restrictUpdate: false
      },()=>{
        this.getMatrix()
      })
    }

    if (this.fetchingUsers && !nextProps.userPending){
      this.setState({
        users: nextProps.users,
        user: nextProps.user,
        showShareModal: true,
        restrictUpdate: true
      }, ()=>{
        this.fetchingUsers = false
      })
    }

    this.handleV2TagsNextProps(nextProps);
    this.handleTrainingRequirementsNextProps(nextProps);
  }

  handleV2TagsNextProps = (nextProps) => {
    if (this.props.v2tags.requestType === nextProps.v2tags.requestType) return
    var { id, name, training_matrix, training_modules, managers } = nextProps.v2tags.tagMatrix

    if (['GET_TAG_MATRIX_SUCCESS', 'UPDATE_TAG_SUCCESS'].includes(nextProps.v2tags.requestType)) {
      this.setState({
        restrictUpdate: false,
        tagId: id,
        tagName: name,
        trainingMatrix: training_matrix,
        trainingModules: training_modules,
        managers: managers,
        loading: false
      })
      this.hideLoadingMessage()
    }
    else {
      this.setState({
        restrictUpdate: true
      })
      this.showLoadingMessage()
    }
  }

  handleTrainingRequirementsNextProps = (nextProps) => {
    if (this.props.trainingRequirements.requestType === nextProps.trainingRequirements.requestType) return
    if ( ['CREATE_TRAINING_REQUIREMENT_SUCCESS', 'UPDATE_TRAINING_REQUIREMENT_SUCCESS'].includes(nextProps.trainingRequirements.requestType)) {
      const { trainingRequirement } = nextProps.trainingRequirements;
      const { trainingMatrix } = this.state;
      const traineeRow = this.getObject(trainingMatrix, trainingRequirement.trainee_id, 'id');
      const flattenedTrainingModules = this.flattenTrainingModules();
      const trainingModule = this.getObject(flattenedTrainingModules, trainingRequirement.module_id, 'id');
      traineeRow[`${trainingModule.category}_${trainingModule.id}`] = trainingRequirement;
      this.setState({ trainingMatrix });
    }
  }

  flattenTrainingModules = () => {
    const { trainingModules } = this.state;
    let flattenedTrainingModules = []
    for (const [, value] of Object.entries(trainingModules)) {
      flattenedTrainingModules = flattenedTrainingModules.concat(value)
    }
    return flattenedTrainingModules
  }

  getMatrix = () => {
    var filterOptions = {
      id: this.state.tagId,
      tag_name: this.state.tagName,
      context: 'regions',
      include_archived_trainees: this.state.includeArchivedTrainees,
      include_archived_modules: false
    }
    this.props.getMatrix(filterOptions)
  }

  updateTrainingRequirement = (details) => {
    if (details.id) {
      this.props.updateTrainingRequirement(details)
    }
    else {
      this.props.createTrainingRequirement(details)
    }
  }

  legendsPopup() {
    return (
      <div id='legends-popup' className='legends-popup'>
        {
          [ 
            {
              label: "Training Completed",
              class: "legends-training-completed"
            },
            {
              label: "Training Needed",
              class: "legends-training-needed"
            },
            {
              label: "Training Overdue",
              class: "legends-training-overdue"
            },
            {
              label: "Expire < 3 months",
              class: "legends-training-due-in-3-months"
            },
            {
              label: "Training Not Needed",
              class: "legends-training-not-needed"
            }
          ].map((item) => {
            return (
              <div key={item.class} className='legends-item'>
                <div className={item.class + ' legends-box'}></div>
                <div className={'capitalize'}>{ item.label }</div>
              </div>
            )
          })
        }
      </div>
    )
  }

  toggleLegendsPopup = (evt) => {
    var offsetTop = 5
    var rect = evt.target.getBoundingClientRect();
    var top = `${rect.top + evt.target.offsetHeight + offsetTop}px`
    var left = `${rect.left}px`
    this.setState({
      legendsPopupShown: !this.state.legendsPopupShown
    }, ()=>{
      if(this.state.legendsPopupShown){
        var popup = document.getElementById('legends-popup')
        popup.style.position = 'absolute'
        popup.style.top = top.toString()
        popup.style.left = left.toString()
      }
    })
  }

  showShareModal = (evt) => {
    this.fetchingUsers = true
    this.props.getUsers()
  }

  exportToExcel = (evt) => {
    this.setState({
      isExporting: true
    })
    var filterOptions = {
      id: this.state.tagId,
      tag_name: this.state.tagName,
      context: 'regions',
      include_archived_trainees: this.state.includeArchivedTrainees,
      include_archived_modules: false,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    this.props.exportToExcel(filterOptions).then((response)=>{
      this.downloadExcelFromBlob(`${this.state.tagName}_${moment(new Date()).format("YYYY-MMM-DD")}.xlsx`, response.data)
      this.setState({
        isExporting: false
      })
    })
  }

  downloadExcelFromBlob = (filename, blob) => {
    const url = window.URL.createObjectURL(new Blob([blob]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', filename);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  toggleArchivedTrainees = (evt) => {
    this.showLoadingMessage()
    this.setState({
      includeArchivedTrainees: !this.state.includeArchivedTrainees,
      restrictUpdate: true
    })
    setTimeout(()=>{
      this.getMatrix()
    }, 10)
  }

  exportArchiveModulesToExcel = (evt) => {
    this.setState({ isExporting: true })
    var filterOptions = {
      id: this.state.tagId,
      tag_name: this.state.tagName,
      context: 'regions',
      include_archived_trainees: this.state.includeArchivedTrainees,
      archived_modules_only: true,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    }
    this.props.exportToExcel(filterOptions).then((response)=>{
      this.downloadExcelFromBlob(`${this.state.tagName}_(Archived Training Modules)_${moment(new Date()).format("YYYY-MMM-DD")}.xlsx`, response.data)
      this.setState({ isExporting: false })
    })
  }

  updateMatrix = (details) => {
    details.old_tag_name = this.state.tagName
    this.props.updateMatrix(details)
  }

  render() {
    const { trainingMatrix, trainingModules } = this.state
    
    return (
      <div className='training-matrix'>
        { 
          this.state.showShareModal &&
          <ShareModal
            show={ this.state.showShareModal }
            onClose={ () => this.setState({ showShareModal: false}) }
            user={this.state.user}
            users={this.state.users}
            managers={this.state.managers}
            tagId={this.state.tagId}
            updateMatrix={this.updateMatrix}
          />
        }
        <div className='matrix-toolbar'>
          {
            <div className='legends-container'>
              <Button primary className='legends-button'
                onClick={this.toggleLegendsPopup}>
                <img src="colors_icon.png" className="icon image" alt=''/>Color Legend
              </Button>
              {
                this.state.legendsPopupShown &&
                <OutClick handleClick={this.toggleLegendsPopup}>{ this.legendsPopup() }</OutClick>  
              }
            </div>
          }
          {
            this.props.user.is_admin &&
            <Button color='teal' fluid size='medium' className='share-button'
              loading={this.fetchingUsers && this.props.userPending}
              onClick={this.showShareModal}>
              <Icon name='users'/>Share
            </Button>
          }
          <div style={{paddingTop: '8px', float: 'left'}}>
            {
              !this.state.isExporting &&
              <span className='anglo-links' onClick={this.exportToExcel}>Export to Excel</span>
            }
            {
              this.state.isExporting &&
              <span className='exporting'><i className="loading circle notched icon"></i> Exporting...</span>
            }
          </div>
          <div style={{paddingTop: '8px', float: 'left'}}>
            {
              !this.state.includeArchivedTrainees &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchivedTrainees}>Show Archived Trainees</span>
            }
            {
              this.state.includeArchivedTrainees &&
              <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.toggleArchivedTrainees}>Hide Archived Trainees</span>
            }
          </div>
          <div style={{paddingTop: '8px', float: 'left'}}>
            { !this.state.isExportingArchived && <span className='anglo-links' style={{marginLeft: '0px'}} onClick={this.exportArchiveModulesToExcel}>Download Archived Modules</span> }
            { this.state.isExportingArchived && <span className='exporting' style={{marginLeft: '0px'}}><i className="loading circle notched icon"></i> Downloading archived modules...</span> }
          </div>
        </div>
        <MatrixTable
          trainingMatrix={ trainingMatrix }
          trainingModules={ trainingModules }
          updateTrainingRequirement={ this.updateTrainingRequirement }
          restrictUpdate={ this.state.restrictUpdate }
          dataLoading={ this.state.loading }
          disabledCells={false}
        />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    users: state.user.users,
    user: state.user.user,
    userPending: state.user.pending,
    v2tags: state.v2tags,
    trainingRequirements: state.trainingRequirements
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getMatrix: (options) => {
      return dispatch(getTagMatrix(options))
    },
    getUsers: () => {
      return dispatch(getUsers())
    },
    updateMatrix: (details) => {
      return dispatch(updateTag(details))
    },
    exportToExcel: (options) => {
      return exportToExcel(options)
    },
    createTrainingRequirement: (options) => {
      return dispatch(createTrainingRequirement(options))
    },
    updateTrainingRequirement: (options) => {
      return dispatch(updateTrainingRequirement(options))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(TagMatrix);



// WEBPACK FOOTER //
// ./src/views/tag_matrix.js